module.exports = __webpack_public_path__ + "img/Subtraction 4.84e12aab.png";